import "../css/index.css"
import "preline"
import Glide from "@glidejs/glide"

// GLIDE

if (document.querySelector(".glide")) {
    const config = {
        type: "carousel",
        perView: 3,
        focusAt: "center",
        gap: 24,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            1200: {
                perView: 3,
            },
            992: {
                perView: 3,
            },
            768: {
                perView: 2,
            },
            576: {
                perView: 1.5,
            },
        },
    }
    new Glide(".glide", config).mount()
}

if (document.querySelector(".glide_testimonials")) {
    const config = {
        type: "carousel",
        perView: 3,
        focusAt: "center",
        gap: 24,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            1200: {
                perView: 3,
            },
            992: {
                perView: 3,
            },
            768: {
                perView: 2,
            },
            576: {
                perView: 1.5,
            },
        },
    }
    new Glide(".glide_testimonials", config).mount()
}

// JS Translation

const nextBtn = document.querySelectorAll(".ld-content-action")

if (nextBtn) {
    nextBtn.forEach(btn => {
        const nextBtnText = btn.querySelectorAll(".ld-text")
        const backBtn = btn.querySelectorAll(".ld-course-step-back")
        nextBtnText.forEach(text => {
            if (text.textContent === "Next Zagadnienie") {
                text.textContent = "Następne"
            }
            if (text.textContent === "Previous Zagadnienie") {
                text.textContent = "Poprzednie"
            }
        })
        backBtn.forEach(text => {
            if (text.textContent === "Back to Szkolenie") {
                text.textContent = "Powrót"
            }
        })
        // const markCompleteBtn = document.querySelectorAll(
        //     ".learndash_mark_complete_button"
        // )
        // markCompleteBtn.forEach(btn => {
        //     btn.textContent = "Ukończone"
        // })

        // const markIncompleteBtn = document.querySelectorAll(
        //     ".learndash_mark_incomplete_button"
        // )
        // markIncompleteBtn.forEach(btn => {
        //     btn.textContent = "Nieukończone"
        // })

        const statusBtn = document.querySelectorAll(".ld-status-progress")
        statusBtn.forEach(btn => {
            if (btn.textContent === "In Progress") {
                btn.textContent = "W trakcie"
            }
        })

        const completeBtn = document.querySelectorAll(".ld-status-complete")
        completeBtn.forEach(btn => {
            if (btn.textContent === "Complete") {
                btn.textContent = "Ukończono"
            }
        })
    })
}

const progressBar = document.querySelector(".ld-progress-wrap")

if (progressBar) {
    const statusText = progressBar.querySelector(".ld-progress-percentage")
    const status = statusText.textContent.split(" ")
    status[1] = "Ukończono"
    statusText.textContent = status.join(" ")

    const progresSteps = progressBar.querySelector(".ld-progress-steps")
    const steps = progresSteps.textContent.split(" ")
    steps[1] = "Kroków"
    progresSteps.textContent = steps.join(" ")
}

const mainprogressBar = document.querySelector(".ld-progress-stats")
if (mainprogressBar) {
    const progressText = mainprogressBar.querySelector(
        ".ld-progress-percentage"
    )
    const progress = progressText.textContent.split(" ")
    progress[1] = "Ukończono"
    progressText.textContent = progress.join(" ")

    const progressSteps = mainprogressBar.querySelector(".ld-progress-steps")
    const steps = progressSteps.textContent.split(" ")
    steps[0] = "Ostatnia"
    steps[1] = "aktywność:"
    steps[2] = ""
    progressSteps.textContent = steps.join(" ")
}
